import React, {useState} from 'react'

const faqs = [
  {
    q: 'Is the Basic plan really free?',
    a: 'Yes. Create listings, share disclosure packages, and receive offers at no cost — no credit card and no time limit.',
  },
  {
    q: 'What do I get with Pro?',
    a:
      'Buyer activity tracking, offer intelligence with net proceeds estimates, one-to-one viewer messaging, templates, and custom branding. Try it free for 14 days.',
  },
  {
    q: 'Can my TC or assistant use it?',
    a: 'Yes. Invite your transaction coordinator or assistant to any listing, on every plan.',
  },
  {
    q: 'I used Disclosures.io. Is this the same product?',
    a: 'Yes. Disclosures.io is now HomeLight Listing Management. Your account, listings, and documents carry over.',
  },
  {
    q: 'How does Team pricing work?',
    a:
      "Team pricing depends on how many agents you have. Contact us and we'll put together a plan, including dedicated onboarding, training, and 1-on-1 support.",
  },
]

function FaqV2() {
  const [openIndex, setOpenIndex] = useState(-1)

  return (
    <section id="faq" className="hlm-faq">
      <div className="hlm-faq-inner">
        <h2>Frequently asked questions</h2>
        <div className="hlm-faq-list">
          {faqs.map((faq, index) => {
            const open = openIndex === index
            return (
              <div className={`hlm-faq-item${open ? ' is-open' : ''}`} key={faq.q}>
                <button
                  type="button"
                  className="hlm-faq-q"
                  aria-expanded={open}
                  onClick={() => setOpenIndex(open ? -1 : index)}>
                  <span>{faq.q}</span>
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" aria-hidden="true">
                    <path d="M5 12h14" />
                    <path d="M12 5v14" />
                  </svg>
                </button>
                {open ? <p className="hlm-faq-a">{faq.a}</p> : null}
              </div>
            )
          })}
        </div>
      </div>
    </section>
  )
}

export default FaqV2
